module.exports = __webpack_public_path__ + "img/paper-and-tea.28132c66.jpg";